/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseInProgressEvent = {
  type: "response.in_progress";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseInProgressEvent$inboundSchema: z.ZodType<
  ResponseInProgressEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.in_progress"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseInProgressEvent$Outbound = {
  type: "response.in_progress";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseInProgressEvent$outboundSchema: z.ZodType<
  ResponseInProgressEvent$Outbound,
  z.ZodTypeDef,
  ResponseInProgressEvent
> = z.object({
  type: z.literal("response.in_progress"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseInProgressEventToJSON(
  responseInProgressEvent: ResponseInProgressEvent,
): string {
  return JSON.stringify(
    ResponseInProgressEvent$outboundSchema.parse(responseInProgressEvent),
  );
}
export function responseInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseInProgressEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseInProgressEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseInProgressEvent' from JSON`,
  );
}
